import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE: 'SAVE',
}

const MANDATORY_FIELDS = {
  STATUS: 'O campo STATUS deve ser preenchido',
  GRUPO: 'O campo GRUPO deve ser preenchido',
}

const INITIAL = {
  id: undefined,
  tp_id: undefined,
  status: '',
  grupo: null,
  active: true,
  padrao: false,
}

export default function useStatusEtiquetaModal() {
  const [state, setState] = useState({
    item: { ...INITIAL },
    loadingMessage: LOAD_MESSAGE.NONE,
    errorMessage: null,
  })

  const localDispatch = useMemo(() => {
    return {
      start(data) {
        setState(prev => ({
          ...prev,
          item: data ? { ...data } : { ...INITIAL },
          errorMessage: null,
          loadingMessage: LOAD_MESSAGE.NONE,
        }))
      },
      onChange(field, value) {
        setState(prev => {
          const item = { ...prev.item, [field]: value }

          if (field === 'grupo' && value !== 'Liberado') {
            item.padrao = false
          }
          if (field === 'active' && !value) {
            item.padrao = false
          }

          return { ...prev, item }
        })
      },

      onBtnSalvarClicked(tp_id) {
        const { status, grupo } = state.item
        if (!status || status.trim().length === 0) {
          setState(prev => ({ ...prev, errorMessage: MANDATORY_FIELDS.STATUS }))
          return
        }
        if (!grupo) {
          setState(prev => ({ ...prev, errorMessage: MANDATORY_FIELDS.GRUPO }))
          return
        }
        setState(prev => ({
          ...prev,
          item: { ...prev.item, tp_id },
          loadingMessage: LOAD_MESSAGE.SAVE,
        }))
      },
      async save(tpId) {
        try {
          const payload = { ...state.item, tp_id: tpId }
          const saved = payload.id
            ? await EstoqueHttp.updateStatusEtiquetaEstoque(tpId, payload)
            : await EstoqueHttp.saveStatusEtiquetaEstoque(tpId, payload)
          setState(prev => ({ ...prev, loadingMessage: LOAD_MESSAGE.NONE }))
          return saved
        } catch (err) {
          setState(prev => ({
            ...prev,
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
          throw new Error(errorHandler(err))
        }
      },
      reset() {
        setState({
          item: { ...INITIAL },
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        })
      },
      clearError() {
        setState(prev => ({ ...prev, errorMessage: null }))
      },
    }
  }, [state.item])

  return { state, localDispatch }
}
